import * as React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>``;

export const ErrorCircleIcon = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width='120'
        height='120'
        viewBox='0 0 120 120'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        role='img'
        aria-label='Error icon'
    >
        <circle
            cx='60'
            cy='60'
            r='52'
            fill='#4a1a24'
            opacity='0.6'
        />
        <circle
            cx='60'
            cy='60'
            r='44'
            fill='#8b2a3a'
            opacity='0.8'
        />
        <circle
            cx='60'
            cy='60'
            r='36'
            fill='#c0392b'
        />
        <path
            d='M47 47 L73 73 M73 47 L47 73'
            stroke='white'
            strokeWidth='8'
            strokeLinecap='round'
        />
    </SvgElement>
);
